import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';

const NodeContextMenu = ({ x, y, onMirror, onClose }) => {
  useEffect(() => {
    const handleKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div
      style={{ top: y, left: x, position: 'fixed', zIndex: 1000 }}
      className="bg-white border border-gray-200 rounded-lg shadow-xl py-1 min-w-44"
    >
      <button
        className="nodrag w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
        onClick={() => {
          onMirror();
          onClose();
        }}
      >
        <ArrowsRightLeftIcon className="w-4 h-4 text-gray-500" />
        Mirror Module
      </button>
    </div>
  );
};

NodeContextMenu.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  onMirror: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NodeContextMenu;
